import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from 'src/app/store/reducers';
import * as fromActions from "./citizen-verify-password.actions";
import * as fromGraphql from "./citizen-verify-password.graphql";
import {map, switchMap} from 'rxjs';


@Injectable()
export class CitizenVerifyPasswordEffects {
  citizenVerifyOtpPassword = createEffect(() => this.actions$.pipe(
    ofType(fromActions.citizenVerifyOtpPassword),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CITIZEN_VERIFY_OPT_PASSWORD,
        variables: {
          passwordOtp: action?.passwordOtp
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(
                fromActions.upsertCitizenVerifyPassword({ citizenVerifyPassword: result?.data })
              );
              this.notificationService.successMessage('Veriefied Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });


  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
